import React, { PureComponent } from 'react'
import { withTheme } from 'styled-components'

import { Label } from 'atoms/Texts'
import { ButtonReg } from 'atoms/Buttons'
import IconPng from 'atoms/IconPng'
import { FormSelect, FormNumber } from 'atoms/Inputs'
import {
  LevelRowContainer,
  Accordion,
  CardContainer,
} from './styles'
import { v4 as uuidv4 } from 'uuid';
import lo from 'lodash';
import { BLASTING_REPORT, BLASTING_REPORT_POSITION_TYPE_BEK } from 'fixtures/api';
import { getLookup } from 'Redux/actions/LookupActions';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NewBlastingReport } from 'fixtures/TemplateData'

const ic_arrow_up = require('App/assets/images/ic_arrow_up.png')
const ic_arrow_down = require('App/assets/images/ic_arrow_down.png')
const ic_cancel = require('App/assets/images/ic_cancel.png')

export class BlastingInventory extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isBlastingInventoryExpanded: false,
    }
  }

  componentDidMount(){
    this.fetchLookup()
  }

  fetchLookup() {
    const { getLookup, toggleIsLoading } = this.props
    toggleIsLoading(true)
    getLookup(BLASTING_REPORT, BLASTING_REPORT_POSITION_TYPE_BEK)
    toggleIsLoading(false)
  }

  showBlastingInventory() {
    const { isBlastingInventoryExpanded } = this.state
    this.setState({ isBlastingInventoryExpanded: !isBlastingInventoryExpanded })
  }

  addPit() {
    const { blastingReportData, fnChange } = this.props
    const reportData = lo.cloneDeep(blastingReportData)
    const details = reportData.details
    const newBlastingInventory = {
      ...lo.cloneDeep(NewBlastingReport.details.blastingInventory[0]),
      id: uuidv4()
    }
    details.blastingInventory.push(newBlastingInventory)
    fnChange(details, 'details')
  }

  removePit(id) {
    const { blastingReportData, fnChange } = this.props
    const reportData = lo.cloneDeep(blastingReportData)
    const details = reportData.details
    // at least 1 pit item, only remove if length > 1
    if (details.blastingInventory.length > 1) {
      const updatedBlastingInventory = details.blastingInventory.filter(pit => pit.id !== id);
      details.blastingInventory = updatedBlastingInventory
      fnChange(details, 'details')
    }
  }

  onChangeVal(value, id, field) {
    const { blastingReportData, fnChange } = this.props
    const reportData = lo.cloneDeep(blastingReportData)
    const details = reportData.details
    const pitIndex = details.blastingInventory.findIndex((pit => pit.id === id));
    details.blastingInventory[pitIndex][field] = value
    fnChange(details, 'details')
  }

  render() {
    const { theme, blastingReportData, lookups, pitOptions, isDisabled, formRefs } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
    }

    return (
      <>
        <Accordion
          color={theme.mocaPurple}
          height={'37px'}
          padding={'0px 12px'}
          bg={'#EBEAFF'}
          mb={this.state.isBlastingInventoryExpanded ? '0' : '8px'}
          onClick={() => this.showBlastingInventory()}
        >
          Blasting Inventory
          {
            this.state.isBlastingInventoryExpanded ? (
              <IconPng srcIcon={ic_arrow_up} mx={"8px"} size={"auto"} h={"10"} />
            ) : (
              <IconPng srcIcon={ic_arrow_down} mx={"8px"} size={"auto"} h={"10"} />
            )
          }
        </Accordion>
        {this.state.isBlastingInventoryExpanded && 
            <CardContainer mb={'16px'}>
              {blastingReportData.hasOwnProperty('details') && 
                <>
                  {blastingReportData.details.blastingInventory.map((pit, idx) => 
                    <div key={idx} className={'row col-12 mx-0 px-0 mb-2'}>
                      <div className={'col-1 px-0 d-flex align-items-center justify-content-center'}>
                        <IconPng srcIcon={ic_cancel} mx={"8px"} size={"auto"} h={"17"} showPointer onClick={() => !isDisabled ? this.removePit(pit.id) : {}}/>
                      </div>
                      <div className={'col-11 px-0'}>
                        <div className={'row col-12 mx-0 px-0'}>
                          <div className={'col-4 px-2'}>
                            <Label lineheight={'14px'} size={'12px'}>
                              PIT
                            </Label>
                            <FormSelect
                              placeholder={'Select PIT'}
                              onChangeVal={e => this.onChangeVal(e.target.value, pit.id, 'pit')}
                              options={pitOptions || []}
                              disabled={isDisabled}
                              value={pit.pit}
                              valField={'id'}
                              dispField={'name'}
                              arrowSize={'16px'}
                              ref={(ref) => (formRefs[`pit_${pit.id}`] = ref)}
                              {...inputConfig}
                            />
                          </div>
                          <div className={'col-4 px-2'}>
                            <Label lineheight={'14px'} size={'12px'}>
                              Position Type
                            </Label>
                            <FormSelect
                              placeholder={'Select Position Type'}
                              onChangeVal={e => this.onChangeVal(e.target.value, pit.id, 'positionType')}
                              options={lookups.blastingReportPositionType || []}
                              value={pit.positionType}
                              disabled={isDisabled}
                              valField={'name'}
                              dispField={'name'}
                              arrowSize={'16px'}
                              ref={(ref) => (formRefs[`positionType_${pit.id}`] = ref)}
                              {...inputConfig}
                            />
                          </div>
                          <div className={'col-4 px-0 pl-2'}>
                            <Label lineheight={'14px'} size={'12px'}>
                              Daily Volume <span style={{color: theme.mocaOrange}}>(BCM)</span>
                            </Label>
                            <div className={'row mx-0 px-0'}>
                              <FormNumber
                                placeholder={'0'}
                                alignRight
                                mb={'16px'}
                                onChangeVal={value => this.onChangeVal(value, pit.id, 'dailyVolume')}
                                value={pit.dailyVolume}
                                disabled={isDisabled}
                                ref={(ref) => (formRefs[`dailyVolume_${pit.id}`] = ref)}
                                {...inputConfig}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              }
              <LevelRowContainer padding={'0px'}>
                <div className={'row col-12 mx-0 px-0 d-flex justify-content-center'}>
                  <ButtonReg transparent btnTxt={'Add PIT'} onClick={() => this.addPit()} disabled={isDisabled} />
                </div>
              </LevelRowContainer>
            </CardContainer>
          }
      </>
    )
  }
}

const mapStateToProps = (state) => {
  let lookups = {}
  if (state.lookups.data && state.lookups.data.BLASTING_REPORT) {
    const blastingReport = state.lookups.data.BLASTING_REPORT
    const blastingReportPositionType = blastingReport.BLASTING_REPORT_POSITION_TYPE_BEK && blastingReport.BLASTING_REPORT_POSITION_TYPE_BEK.find((d) => d.name === 'POSITION_TYPE')
    lookups.blastingReportPositionType = blastingReportPositionType ? blastingReportPositionType.children.map((d) => ({ name: d.nameDisplay })) : []
  }
  return {
    lookups
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
      getLookup
    },
    dispatch
  )

export default withTheme(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(BlastingInventory)
)
